import { isCardCode } from "@/features/card/lib/card-code";
import { lastCardPath } from "@/features/card/lib/last-card";

export function loginReturnPath(raw: string | null): string {
	if (raw?.startsWith("/") && !raw.startsWith("//")) {
		const path = raw.split("?")[0] as string;
		const code = path.replace(/^\//, "").split("/")[0];
		if (isCardCode(code)) {
			return path;
		}
	}
	return lastCardPath() ?? "/";
}
